import React from 'react'
import styles from './styles.module.css'
import SimpleBlockContent from '../../../../SimpleBlockContent'
import Img from '../../../../Img' // task #67: canonical image component
import HighlightedText from '../../../../Utils/HighlightedText'

function R295Customization({ mainTitleHl, text, mainImageCs }) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.contentWrapper}>
        <HighlightedText {...mainTitleHl}
                         highlightExactMatch={true}
        />
        <div className={styles.textWrapper}>
          <div className={styles.textBody}>
            <SimpleBlockContent blocks={text} noSpace/>
          </div>
        </div>
        {
          mainImageCs && (
            <div className={styles.mainImage}>
              {/* task #67: descriptor via <Img> */}
              <Img
                image={mainImageCs.image}
                alt={mainImageCs.alt}
                objectFit="contain"
              />
            </div>
          )
        }
      </div>
    </div>
  )
}

export default R295Customization
